<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>赔付审核列表</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                v-if="resData"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <el-form-item label="输入搜索:">
                  <el-select
                    v-model="form.pgid"
                    placeholder="选择代采组"
                    filterable
                    clearable
                    @keyup.native.enter="search"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                      v-for="item in resData.option_pg"
                      :key="item.key"
                      :value="item.key"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.pf_no"
                    placeholder="赔付单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.storehouse_id"
                    placeholder="仓库"
                    @keyup.native.enter="search"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                      v-for="item in resData.option_stock"
                      :key="item.key"
                      :value="item.key"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pf_type"
                    placeholder="赔付类型"
                    @keyup.native.enter="search"
                  >
                    <el-option
                      v-for="item in resData.option_compensate_type"
                      :key="item.key"
                      :value="item.key"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pf_status"
                    placeholder="赔付单状态"
                    @keyup.native.enter="search"
                  >
                    <el-option
                      v-for="item in resData.option_compensate_status"
                      :key="item.key"
                      :value="item.key"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pay_tool"
                    placeholder="支付方式"
                    @keyup.native.enter="search"
                  >
                    <el-option
                      v-for="item in resData.option_compensate_paytool"
                      :key="item.key"
                      :value="item.key"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.bill_id"
                    placeholder="账单编号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form
                v-if="resData"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <el-form-item>
                  <el-input
                    v-model="form.member_name"
                    placeholder="仓库审核人/代采提交人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_on_sale"
                    placeholder="是否包含下架商品"
                    @keyup.native.enter="search"
                  >
                    <el-option
                      v-for="item in resData.option_on_sale"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="赔付单创建日期">
                  <el-date-picker
                    v-model="form.created_at"
                    type="datetimerange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="支付时间：">
                  <el-date-picker
                    v-model="form.payment_at"
                    type="datetimerange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button type="info" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <div style="margin-left: auto">
            <el-button type="primary" size="mini" @click="handleMultipleAudit">
              仓库批量审核
            </el-button>
            <el-button type="primary" size="mini" @click="handleExport">
              导出列表
            </el-button>
            <el-button type="success" size="mini" @click="handleOutput">
              导出商品明细
            </el-button>
          </div>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="pf_no"
              label="赔付单号"
              show-overflow-tooltip
              align="center"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="pf_created_at"
              label="赔付单日期"
              show-overflow-tooltip
              align="center"
              width="160"
            >
            </el-table-column>

            <el-table-column
              prop="pf_type_msg"
              label="赔付类型"
              width="80"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pay_tool_msg"
              label="支付方式"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家名称"
              show-overflow-tooltip
              align="center"
              width="200"
            >
            </el-table-column>
            <el-table-column
              prop="city"
              label="城市"
              width="80"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="market_name"
              label="市场"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="brand"
              label="品牌"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_member_name"
              label="代采员"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="defective_group_member_name"
              label="售后退供员"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="storehouse_name"
              label="仓库"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_member_name"
              label="创建人"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="storehouse_member_name"
              label="仓库审核人"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="storehouse_examine_at"
              label="仓库审核时间"
              width="160"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="purchase_member_name"
              label="代采提交人"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="purchase_examine_at"
              label="代采提交时间"
              width="160"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_num"
              label="商品数量"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="total_origin_market_price"
              label="原拿货总金额"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="total_pf_price"
              label="赔付总金额"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="diff_price"
              label="差额"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="stock_in_num"
              label="入库数量"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="status_msg"
              label="赔付单状态"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="pay_member_name"
              label="支付人"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="bill_id"
              label="账单编号"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="payment_at"
              label="支付时间"
              width="160"
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              width="100"
              align="center"
              fixed="right"
            >
              <template #default="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleDetail(scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="form.page"
            background
            layout="total, prev, pager, next, jumper, sizes "
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[10, 50, 100, 200, 500, 1000]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="isShowAuditModal"
      title="仓库批量审核"
      @close="handleAuditModalClose"
    >
      <el-form ref="auditForm" :model="auditForm" label-width="80px">
        <el-form-item
          label="操作方式"
          prop="check_type"
          :rules="rules.ruleBlur"
        >
          <el-radio-group v-model="auditForm.check_type">
            <el-radio label="1">通过</el-radio>
            <el-radio label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="log_remark">
          <el-input
            v-model="auditForm.log_remark"
            type="textarea"
            placeholder="操作备注"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="isShowAuditModal = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmAuditModal"
          >确定</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getIndexList,
  exportDetailList,
} from "@/controller/goodsCompensate.js";
import apiBaseURL from "@/utils/baseUrl.js";
import rules from "@/const/rules.js";
import { postBatchStorehouseAdoptCompensate } from "@/openapi/erp/goodsCompensate";

function defaultDate() {
  const endDate = new Date();
  const endM =
    endDate.getMonth() + 1 < 10
      ? `0${endDate.getMonth() + 1}`
      : endDate.getMonth() + 1;
  const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 31);
  const startM =
    startDate.getMonth() + 1 < 10
      ? `0${startDate.getMonth() + 1}`
      : startDate.getMonth() + 1;
  const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
  return [start, end];
}
export default {
  name: "CompensateList",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      rules,
      loading: false,
      filterFold: false,
      resData: null,
      total: 0,
      form: {
        page: 1,
        pagesize: 50,
        pf_no: "", // 赔付单号
        pgid: "", // 代采组id
        supply_name: "", // 商家名称
        storehouse_id: "", // 仓库ID
        pf_type: "", // 赔付类型
        pf_status: "", // 赔付状态
        pay_tool: "", // 支付方式
        member_name: "", // 代采人名称/仓库名称
        is_on_sale: "", // 是否包含下架
        created_at: defaultDate(), // 赔付单 创建日期
        payment_at: [], // 支付时间
        is_excel: "0",
        export_ids: [], // 导出id
        bill_id: "",
      },
      multipleSelection: [],
      isShowAuditModal: false,
      auditForm: {
        check_type: "",
        log_remark: "",
      },
    };
  },
  methods: {
    search() {
      this.form.page = 1;
      this.fetchData();
      console.log(this.form);
    },
    reset() {
      this.form = this.$options.data().form;
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    // 导出明细
    handleOutput() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("请先选择赔付单号");
      } else {
        const exportIds = this.multipleSelection.map((item) => {
          return item.id;
        });
        exportDetailList({ export_ids: exportIds })
          .then((data) => {
            this.$message.success("导出成功");
            const { file } = data;
            window.open(apiBaseURL + file);
            this.fetchData();
          })
          .catch(this.$noop);
      }
    },
    handleMultipleAudit() {
      if (this.multipleSelection.length === 0) {
        this.$message.info("请先选择赔付单号");
      } else {
        this.isShowAuditModal = true;
      }
    },
    // 导出列表
    handleExport() {
      if (this.multipleSelection.length === 0) {
        this.$message.info("请先选择赔付单号");
      } else {
        const exportIds = this.multipleSelection.map((item) => {
          return item.id;
        });
        getIndexList({ ...this.form, is_excel: 1, export_ids: exportIds })
          .then((data) => {
            this.$message.success("导出成功");
            const { file } = data;
            window.open(apiBaseURL + file);
          })
          .catch(this.$noop);
      }
    },
    fetchData() {
      getIndexList(this.form)
        .then((res) => {
          this.resData = res;
        })
        .catch(this.$noop);
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 查看详情
    handleDetail(row) {
      this.$router.push(`/home/storage/compensatelist/detail?pf_id=${row.id}`);
    },
    handleAuditModalClose() {
      this.$refs.auditForm.resetFields();
    },
    handleConfirmAuditModal() {
      this.$refs.auditForm.validate((valid) => {
        if (valid) {
          postBatchStorehouseAdoptCompensate({
            ...this.auditForm,
            pf_ids: this.multipleSelection.map((item) => {
              return item.id;
            }),
          })
            .then((res) => {
              if (res.msg) {
                this.$message.error(res.msg);
              } else {
                this.$message.success("操作成功");
              }
              this.isShowAuditModal = false;
              this.fetchData();
            })
            .catch(this.$noop);
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/CompensateList.vue